/**
 * Cookie should expire virtually never. This is okay because
 * client will automatically delete invalid cookies (determined on server)
 */

export default new Date('2038-01-01')
